import useEntity from "../../hooks/useBuyer";
import BuyerDetail from "../../components/buyer/BuyerDetail/BuyerDetail";
import BuyerScoped from "../../components/buyer/BuyerDetail/BuyerScoped";
import BuyerTabs from "../../components/buyer/BuyerDetail/BuyerTabs";
import { useGetBuyerQuery } from "../../apis/Buyer.api";
import { PrimaryBuyer } from "../../types/models/Buyer";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const BuyerDetailPage = () => {

    useTitle(t`Details Buyer`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { buyerId: id } = useParams();

    const { data, refetch } = useGetBuyerQuery(PrimaryBuyer.fromPath(id))
    const { deleteBuyer } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteBuyer(data, '..')
    }, [data, deleteBuyer])

    if (id === 'scoped') {
        return (<BuyerScoped/>)
    }

    return (
        <Box data-testid="Buyer-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <BuyerDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em"}}>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Buyers/update/view'
        ) ||
session.hasPermission(
            data.buyerScopeGroupId,
            'applications/timber/entities/Buyers/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="Buyer-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Buyers/delete/view'
        ) ||
session.hasPermission(
            data.buyerScopeGroupId,
            'applications/timber/entities/Buyers/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="Buyer-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <BuyerTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default BuyerDetailPage;
